import { render } from "./YoutubeSvg.vue?vue&type=template&id=2622eb4f"
import script from "./YoutubeSvg.vue?vue&type=script&lang=ts"
export * from "./YoutubeSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script